module.exports = __webpack_public_path__ + "798bc58563830174bb6399253e995804.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/jogo-do-bicho/limpar.png
// module id = 1039
// module chunks = 0